import { type DashRouteType, URL_APP_ADMIN } from '@retailer-platform/dashboard/routing'

// Base URLs
const URL_ADMIN_CUSTOMERS_AND_ORDERS = `${URL_APP_ADMIN}/customers-and-orders`

const URL_ADMIN_CUSTOMERS_AND_ORDERS_DASHBOARD = `${URL_ADMIN_CUSTOMERS_AND_ORDERS}/dashboard`
const URL_ADMIN_CUSTOMERS_AND_ORDERS_LEGACY_PAGE_IFRAME = `${URL_ADMIN_CUSTOMERS_AND_ORDERS_DASHBOARD}/admin`
const URL_ADMIN_CUSTOMERS_AND_ORDERS_LEGACY_CARE_PAGE_IFRAME = `${URL_ADMIN_CUSTOMERS_AND_ORDERS_DASHBOARD}/admin/care`
const URL_ADMIN_CUSTOMERS_AND_ORDERS_DASHBOARD_WILDCARD = `${URL_ADMIN_CUSTOMERS_AND_ORDERS_DASHBOARD}/*`
export const URL_ADMIN_CUSTOMERS_AND_ORDERS_IPP_BASE = `${URL_ADMIN_CUSTOMERS_AND_ORDERS}/care`

// New IPP Admin Pages
const URL_ADMIN_CUSTOMERS_AND_ORDERS_IPP_SEARCH = `${URL_ADMIN_CUSTOMERS_AND_ORDERS_IPP_BASE}/search`
const URL_ADMIN_IPP_CUSTOMER_DETAILS = `${URL_ADMIN_CUSTOMERS_AND_ORDERS_IPP_BASE}/customers/:customerId`
const URL_ADMIN_IPP_CUSTOMER_ORDERS_LIST = `${URL_ADMIN_IPP_CUSTOMER_DETAILS}/orders`
const URL_ADMIN_IPP_CUSTOMER_ORDER_DETAILS = `${URL_ADMIN_IPP_CUSTOMER_ORDERS_LIST}/:orderId`
const URL_ADMIN_CUSTOMERS_AND_ORDERS_NOT_FOUND = `${URL_ADMIN_CUSTOMERS_AND_ORDERS}/not_found`

// Legacy Care Admin Pages
const URL_ADMIN_LEGACY_CARE_CUSTOMER_DETAILS = `${URL_ADMIN_CUSTOMERS_AND_ORDERS_LEGACY_CARE_PAGE_IFRAME}/customers/:customerId`
const URL_ADMIN_LEGACY_CARE_ORDER_DETAILS = `${URL_ADMIN_LEGACY_CARE_CUSTOMER_DETAILS}/order/:orderId`
const URL_ADMIN_LEGACY_CARE_CUSTOMER_PROMOS_CREDITS = `${URL_ADMIN_CUSTOMERS_AND_ORDERS_LEGACY_CARE_PAGE_IFRAME}/promo_codes?customer_id=:customerId`

// Legacy Admin Pages
const URL_ADMIN_LEGACY_CUSTOMER_DETAILS = `${URL_ADMIN_CUSTOMERS_AND_ORDERS_LEGACY_PAGE_IFRAME}/customers/:customerId`
const URL_ADMIN_LEGACY_CUSTOMER_A_B_TESTS = `${URL_ADMIN_LEGACY_CUSTOMER_DETAILS}/ab_tests`
const URL_ADMIN_LEGACY_CUSTOMER_CART_ITEMS = `${URL_ADMIN_LEGACY_CUSTOMER_DETAILS}/cart_items`
const URL_ADMIN_LEGACY_CUSTOMER_CASES = `${URL_ADMIN_LEGACY_CUSTOMER_DETAILS}/cases`
const URL_ADMIN_LEGACY_CUSTOMER_CHARGES_REFUNDS = `${URL_ADMIN_LEGACY_CUSTOMER_DETAILS}/charge_logs`
const URL_ADMIN_LEGACY_CUSTOMER_DONATIONS = `${URL_ADMIN_LEGACY_CUSTOMER_DETAILS}/donations`
const URL_ADMIN_LEGACY_CUSTOMER_FRAUD_SCORE = `${URL_ADMIN_LEGACY_CUSTOMER_DETAILS}/fraud_score`
const URL_ADMIN_LEGACY_CUSTOMER_HOLDS_AND_FLAGS = `${URL_ADMIN_LEGACY_CUSTOMER_DETAILS}/customer_flags`
const URL_ADMIN_LEGACY_CUSTOMER_NOTES = `${URL_ADMIN_LEGACY_CUSTOMER_DETAILS}/notes`
const URL_ADMIN_LEGACY_CUSTOMER_NOTIFICATIONS = `${URL_ADMIN_LEGACY_CUSTOMER_DETAILS}/notifications`
const URL_ADMIN_LEGACY_CUSTOMER_COUPONS = `${URL_ADMIN_LEGACY_CUSTOMER_DETAILS}/coupons`
const URL_ADMIN_LEGACY_CUSTOMER_RELATED_ACCOUNTS = `${URL_ADMIN_LEGACY_CUSTOMER_DETAILS}#related`
const URL_ADMIN_LEGACY_CUSTOMER_LINKED_USERS = `${URL_ADMIN_LEGACY_CUSTOMER_DETAILS}#linked`
const URL_ADMIN_LEGACY_CUSTOMER_SUBSCRIPTIONS = `${URL_ADMIN_LEGACY_CUSTOMER_DETAILS}/subscriptions`
const URL_ADMIN_LEGACY_CUSTOMER_TIMELINE = `${URL_ADMIN_LEGACY_CUSTOMER_DETAILS}/timeline`
const URL_ADMIN_LEGACY_CUSTOMER_VISITS = `${URL_ADMIN_LEGACY_CUSTOMER_DETAILS}/visits`

const URL_ADMIN_LEGACY_CUSTOMER_MARQETA_TRANSACTIONS = `${URL_ADMIN_LEGACY_CUSTOMER_DETAILS}/marqeta-transactions`

const URL_ADMIN_LEGACY_BATCH_DETAILS = `${URL_ADMIN_CUSTOMERS_AND_ORDERS_LEGACY_PAGE_IFRAME}/batches/:batchId`

const URL_ADMIN_LEGACY_CUSTOMER_EDIT = `${URL_ADMIN_LEGACY_CUSTOMER_DETAILS}/edit`
const URL_ADMIN_LEGACY_CUSTOMER_IMPERSONATE = `${URL_ADMIN_LEGACY_CUSTOMER_DETAILS}/impersonate`
const URL_ADMIN_LEGACY_CUSTOMER_ESCALATE_FLAG = `${URL_ADMIN_LEGACY_CUSTOMER_DETAILS}`
const URL_ADMIN_LEGACY_CUSTOMER_WATCH_FLAG = `${URL_ADMIN_LEGACY_CUSTOMER_DETAILS}`
const URL_ADMIN_LEGACY_CUSTOMER_DEACTIVATE_ACCOUNT = `${URL_ADMIN_LEGACY_CUSTOMER_DETAILS}/toggle_activation`

export type DashRouteSet = DashRouteType<
  | 'app-admin-customers-and-orders'
  | 'app-admin-customers-and-orders-dashboard'
  | 'app-admin-customers-and-orders-dashboard-legacy'
  | 'app-admin-customers-and-orders-dashboard-wildcard'
  | 'app-admin-customers-and-orders-ipp-customer-order-history'
  | 'app-admin-customers-and-orders-ipp-customer-search'
  | 'app-admin-customers-and-orders-ipp-customer-details'
  | 'app-admin-customers-and-orders-legacy-care-customer-details'
  | 'app-admin-customers-and-orders-legacy-care-order-details'
  | 'app-admin-customers-and-orders-ipp-customer-orders-list'
  | 'app-admin-customers-and-orders-ipp-customer-order-details'
  | 'app-admin-customers-and-orders-legacy-customer-coupons'
  | 'app-admin-customers-and-orders-legacy-care-customer-promotion-search'
  | 'app-admin-customers-and-orders-legacy-customer-a-b-tests'
  | 'app-admin-customers-and-orders-legacy-customer-cart-items'
  | 'app-admin-customers-and-orders-legacy-customer-cases'
  | 'app-admin-customers-and-orders-legacy-customer-charges-refunds'
  | 'app-admin-customers-and-orders-legacy-customer-donations'
  | 'app-admin-customers-and-orders-legacy-customer-fraud-score'
  | 'app-admin-customers-and-orders-legacy-customer-holds-and-flags'
  | 'app-admin-customers-and-orders-legacy-customer-notes'
  | 'app-admin-customers-and-orders-legacy-customer-notifications'
  | 'app-admin-customers-and-orders-legacy-care-customer-promos-credits'
  | 'app-admin-customers-and-orders-legacy-customer-related-accounts'
  | 'app-admin-customers-and-orders-legacy-customer-linked-users'
  | 'app-admin-customers-and-orders-legacy-customer-subscriptions'
  | 'app-admin-customers-and-orders-legacy-customer-timeline'
  | 'app-admin-customers-and-orders-legacy-customer-visits'
  | 'app-admin-customers-and-orders-legacy-customer-marqeta-transactions'
  | 'app-admin-customers-and-orders-not-found'
  | 'app-admin-customers-and-orders-legacy-edit-customer'
  | 'app-admin-customers-and-orders-legacy-customer-impersonate'
  | 'app-admin-customers-and-orders-legacy-customer-details'
  | 'app-admin-customers-and-orders-legacy-escalate-flag'
  | 'app-admin-customers-and-orders-legacy-watch-flag'
  | 'app-admin-customers-and-orders-legacy-deactivate-account'
  | 'app-admin-customers-and-orders-legacy-batch-details'
>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'app-admin-customers-and-orders': URL_ADMIN_CUSTOMERS_AND_ORDERS,
  'app-admin-customers-and-orders-dashboard': URL_ADMIN_CUSTOMERS_AND_ORDERS_DASHBOARD,
  'app-admin-customers-and-orders-dashboard-legacy':
    URL_ADMIN_CUSTOMERS_AND_ORDERS_LEGACY_PAGE_IFRAME,
  'app-admin-customers-and-orders-dashboard-wildcard':
    URL_ADMIN_CUSTOMERS_AND_ORDERS_DASHBOARD_WILDCARD,
  'app-admin-customers-and-orders-ipp-customer-order-history': URL_ADMIN_IPP_CUSTOMER_ORDERS_LIST,
  'app-admin-customers-and-orders-ipp-customer-search': URL_ADMIN_CUSTOMERS_AND_ORDERS_IPP_SEARCH,
  'app-admin-customers-and-orders-ipp-customer-details': URL_ADMIN_IPP_CUSTOMER_DETAILS,
  'app-admin-customers-and-orders-legacy-care-customer-details':
    URL_ADMIN_LEGACY_CARE_CUSTOMER_DETAILS,
  'app-admin-customers-and-orders-legacy-care-order-details': URL_ADMIN_LEGACY_CARE_ORDER_DETAILS,
  'app-admin-customers-and-orders-ipp-customer-orders-list': URL_ADMIN_IPP_CUSTOMER_ORDERS_LIST,
  'app-admin-customers-and-orders-ipp-customer-order-details': URL_ADMIN_IPP_CUSTOMER_ORDER_DETAILS,
  // @hygen:inject route-pair
  'app-admin-customers-and-orders-legacy-customer-coupons': URL_ADMIN_LEGACY_CUSTOMER_COUPONS,
  'app-admin-customers-and-orders-legacy-care-customer-promotion-search':
    URL_ADMIN_LEGACY_CARE_CUSTOMER_PROMOS_CREDITS,
  'app-admin-customers-and-orders-legacy-customer-a-b-tests': URL_ADMIN_LEGACY_CUSTOMER_A_B_TESTS,
  'app-admin-customers-and-orders-legacy-customer-cart-items': URL_ADMIN_LEGACY_CUSTOMER_CART_ITEMS,
  'app-admin-customers-and-orders-legacy-customer-cases': URL_ADMIN_LEGACY_CUSTOMER_CASES,
  'app-admin-customers-and-orders-legacy-customer-charges-refunds':
    URL_ADMIN_LEGACY_CUSTOMER_CHARGES_REFUNDS,
  'app-admin-customers-and-orders-legacy-customer-donations': URL_ADMIN_LEGACY_CUSTOMER_DONATIONS,
  'app-admin-customers-and-orders-legacy-customer-fraud-score':
    URL_ADMIN_LEGACY_CUSTOMER_FRAUD_SCORE,
  'app-admin-customers-and-orders-legacy-customer-holds-and-flags':
    URL_ADMIN_LEGACY_CUSTOMER_HOLDS_AND_FLAGS,
  'app-admin-customers-and-orders-legacy-customer-notes': URL_ADMIN_LEGACY_CUSTOMER_NOTES,
  'app-admin-customers-and-orders-legacy-customer-notifications':
    URL_ADMIN_LEGACY_CUSTOMER_NOTIFICATIONS,
  'app-admin-customers-and-orders-legacy-care-customer-promos-credits':
    URL_ADMIN_LEGACY_CUSTOMER_COUPONS,
  'app-admin-customers-and-orders-legacy-customer-related-accounts':
    URL_ADMIN_LEGACY_CUSTOMER_RELATED_ACCOUNTS,
  'app-admin-customers-and-orders-legacy-customer-linked-users':
    URL_ADMIN_LEGACY_CUSTOMER_LINKED_USERS,
  'app-admin-customers-and-orders-legacy-customer-subscriptions':
    URL_ADMIN_LEGACY_CUSTOMER_SUBSCRIPTIONS,
  'app-admin-customers-and-orders-legacy-customer-timeline': URL_ADMIN_LEGACY_CUSTOMER_TIMELINE,
  'app-admin-customers-and-orders-legacy-customer-visits': URL_ADMIN_LEGACY_CUSTOMER_VISITS,
  'app-admin-customers-and-orders-legacy-customer-marqeta-transactions':
    URL_ADMIN_LEGACY_CUSTOMER_MARQETA_TRANSACTIONS,
  'app-admin-customers-and-orders-not-found': URL_ADMIN_CUSTOMERS_AND_ORDERS_NOT_FOUND,
  'app-admin-customers-and-orders-legacy-customer-details': URL_ADMIN_LEGACY_CUSTOMER_DETAILS,
  'app-admin-customers-and-orders-legacy-edit-customer': URL_ADMIN_LEGACY_CUSTOMER_EDIT,
  'app-admin-customers-and-orders-legacy-customer-impersonate':
    URL_ADMIN_LEGACY_CUSTOMER_IMPERSONATE,
  'app-admin-customers-and-orders-legacy-escalate-flag': URL_ADMIN_LEGACY_CUSTOMER_ESCALATE_FLAG,
  'app-admin-customers-and-orders-legacy-watch-flag': URL_ADMIN_LEGACY_CUSTOMER_WATCH_FLAG,
  'app-admin-customers-and-orders-legacy-deactivate-account':
    URL_ADMIN_LEGACY_CUSTOMER_DEACTIVATE_ACCOUNT,
  'app-admin-customers-and-orders-legacy-batch-details': URL_ADMIN_LEGACY_BATCH_DETAILS,
}
export type DomainRouteName = keyof typeof routes
